import { createUseStyles } from 'react-jss'

export default createUseStyles({
  container: {
    backgroundColor: 'var(--section__background__color)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
})
